import { defineStore } from 'pinia';
import { strapi } from '~/stores/transport/strapi';
import { assignDataToFields } from '~/utils/strapiComponents/addStrapiData';

export const useStoreModalEstonian = defineStore('modalEstonian', {
  state: () => ({
    text: '',
    buttonTextLink: '',
    buttonTextClose: '',
    locale: '',
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadEstonianModal() {
      if (!this.requestPromise) {
        this.requestPromise = strapi()
          .get('estonian-modal')
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
